export const styles = (theme) => ({
  root: {
    margin: 0,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "400px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  card: {
    textAlign: "center",
    border: "1px solid #F3F3F3",
    padding: 0,
    height: "100%"
  },
  cardTitle: {
    padding: "8px 30px",
    backgroundColor: "#f3f3f3",
    fontSize: 13,
    fontWeight: 600,
  },
  recordTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  boldFont: {
    fontWeight: 600,
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
});